import { Box, Paper, Stack, Tooltip } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { CommonGridToolBarWithFilterText, CommonPatientDetails } from '../../../../Components/Common Components/CommonComponents';
import { Colors } from '../../../../Styles/Colors';
import { getCachevalue, localGetItem } from '../../../../Utility/Services/CacheProviderService';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { DataGrid } from '@mui/x-data-grid';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { AmountFormat, formatDate } from '../../../../Components/CommonFunctions/CommonFunctions';
import { CurrencySymbol } from '../../../../Utility/Constants';

const RadOrder = () => {
    const [patientData, setPatientData] = useState(null);
    const [orderList, setOrderList] = useState([]);
    const [isErrorMsg, setIsErrorMsg] = useState(false);
    const [isErrorMsgText, setIsErrorMsgText] = useState('');
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [isLoader, setIsLoader] = useState(false);

    useEffect(() => {
        const patientData = JSON.parse(getCachevalue('RadPatientData'));
        setPatientData(patientData);
        getOrderList(patientData)
    }, []);

    const errorMessage = (message) => {
        setIsErrorMsgText(message);
        setIsErrorMsg(true);
    };

    const getOrderList = (data) => {
        try {
            setIsLoader(true);
            RestAPIService.getAll((localGetItem('is_investigation_module') === "true" ? Serviceurls.NEW_INVESTIGATION_PATIENT_ORDER : Serviceurls.NEW_RAD_PATIENT_ORDER) + `?appointment_id=${data?.appointment_id || ''}&patient_id=${data?.patient_id}&ip_admission_id=${data?.ip_admission_id || ''}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setIsLoader(false);
                        setOrderList(response?.data?.data || [])
                    }
                }).catch((error) => {
                    setIsLoader(false);
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            setIsLoader(false);
            errorMessage(error.message)
        }
    }

    const gridToolBar = () => {
        let TextArray = [
        ]
        return (
            <Box>
                <CommonGridToolBarWithFilterText FilterTextArray={TextArray} filename={"Radiology Order"} />
            </Box>
        )
    }

    const columns = [
        { field: "order_item_number", headerName: "Order Number", flex: 1.5 },
        {
            field: "created_date",
            flex: 1,
            headerName: "Created Date",
            headerAlign: "center",
            align: "center",
            renderCell: (params) => (
                <Box>
                    {params?.row?.created_date ? formatDate(params?.row?.created_date) : "-"}
                </Box>
            )
        },
        {
            field: "service_head_code", headerName: "Service Head", flex: 2.5, renderCell: (params) => {
                const serviceHead = params?.row?.service_head_name || "";
                const serviceCode = params?.row?.service_head_code || "";
                const combinedText = `${serviceCode} - ${serviceHead}`;
                return (
                    <Box>
                        {combinedText.length > 30 ? (
                            <Tooltip placement="top" title={combinedText} arrow>
                                <div>{combinedText.slice(0, 30) + "..."}</div>
                            </Tooltip>
                        ) : (
                            combinedText || "-"
                        )}
                    </Box>
                )
            }, valueGetter: (params) => {
                const serviceHead = params?.row?.service_head_name || "";
                const serviceCode = params?.row?.service_head_code || "";
                return `${serviceCode} - ${serviceHead}`;
            }
        },
        {
            field: "service_code", headerName: "Service Name", flex: 2.5, renderCell: (params) => {
                const serviceCode = params?.row?.service_code || "";
                const serviceName = params?.row?.service_name || "";
                const combinedText = `${serviceCode} - ${serviceName}`;
                return (
                    <Box>
                        {combinedText.length > 30 ? (
                            <Tooltip placement="top" title={combinedText} arrow>
                                <div>{combinedText.slice(0, 30) + "..."}</div>
                            </Tooltip>
                        ) : (
                            combinedText || "-"
                        )}
                    </Box>
                )
            }, valueGetter: (params) => {
                const serviceCode = params?.row?.service_code || "";
                const serviceName = params?.row?.service_name || "";
                return `${serviceCode} - ${serviceName}`;
            }
        },
        {
            field: "total_amount",
            flex: 1,
            headerName: `${"Amount"} (${CurrencySymbol})`,
            type: "number",
            renderCell: (params) => (
                <Box>
                    {params?.row?.total_amount ? AmountFormat(params?.row?.total_amount) : "0.00"}
                </Box>
            )
        },
        { field: "created_by", headerName: "Created By", flex: 1 },
    ];

    return (
        <Box component={'div'}>
            <Box component={'div'} sx={{ backgroundColor: Colors.Background, height: '79vh' }}>
                <Box component={'div'} height={"9.5vh"} paddingTop={'0.1vw'}>
                    <Box component={'div'} className='eMed_nur_notes_details' ml={'1vw'}>
                        <CommonPatientDetails data={patientData} showDetailed={(patientData?.op_number || patientData?.ip_number) ? true : false} />
                    </Box>
                </Box>
                <Box component={'div'} mr={'0.5vw'} height={'65vh'}>
                    <Box component="div" className="eMed_Table_Container" sx={{ height: "68vh" }}>
                        <Stack component="div">
                            <Paper className="eMed_Table_Wrapper">
                                <DataGrid
                                    rows={orderList}
                                    columns={columns}
                                    page={page}
                                    pageSize={pageSize}
                                    hideFooterSelectedRowCount
                                    localeText={{
                                        toolbarColumns: "",
                                        toolbarDensity: "",
                                        toolbarExport: "",
                                        toolbarFilters: "",
                                        toolbarExportPrint: ""
                                    }}
                                    headerHeight={40}
                                    components={{
                                        Toolbar: gridToolBar,
                                        NoRowsOverlay: () => (
                                            <Stack className="eMed_conf_nodata">
                                                {"No Records Found"}
                                            </Stack>
                                        )
                                    }}
                                    rowsPerPageOptions={[10, 20, 30]}
                                    disableSelectionOnClick
                                    pagination
                                    onPageChange={(newPage) => setPage(newPage)}
                                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                    loading={isLoader}
                                />
                            </Paper>
                        </Stack>
                    </Box>
                </Box>
            </Box>
            {isErrorMsg && (
                <ToastMsg
                    severity="error"
                    msg={isErrorMsgText}
                    msgPop={() => setIsErrorMsg(false)}
                />
            )}
        </Box>
    );
};

export default RadOrder;